/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-statements */
import { deepCopy } from '../helpers';
import { ProcessRawBlueprint } from './process-raw-blueprint.class';
import { updates } from './updates';
import { BLUEPRINT_SCHEMA_VERSION, BlueprintData } from '../blueprint-classes';
import { RawBlueprint, UnknownBlueprint } from './types';

export class SchemaUpdate {
	#bpUnknown: unknown;
	#bpData: BlueprintData;
	#bpSchemaVersion: number;
	readonly currentSchemaVersion = BLUEPRINT_SCHEMA_VERSION;

	constructor (bp: unknown) {
		this.#bpUnknown = bp;

		// get schema from raw payload
		const bpUnproceesedSchemaVersion: number | null = (bp as any).schemaVersion ?? null;

		// look for raw = -1, null = update saved BP that are missing schemaVersion to 5
		this.#bpSchemaVersion = bpUnproceesedSchemaVersion === null && JSON.parse((bp as any).state || '[]').length === 0
			? -1
			: bpUnproceesedSchemaVersion === null ? 5 : bpUnproceesedSchemaVersion;

		if (this.#bpSchemaVersion >= 5 && (bp as any).state) {
			// updatedBlueprint.islands = JSON.parse((updatedBlueprint.islands) as unknown as string);
			(bp as any).state = JSON.parse(((bp as any).state) as unknown as string);
		} else if (this.#bpSchemaVersion === 6 && !(bp as any).state) {
			// really a 7,  some schemas were marked as 6 but are actually 7
			this.#bpSchemaVersion = 7;
		}
		console.log('schema-update:current-schema-version', bpUnproceesedSchemaVersion);

		// passthrough if version matches current, otherwise process raw or update as required
		switch (this.#bpSchemaVersion) {
			case this.currentSchemaVersion:
				console.log(`schema-update:schema-current:${this.currentSchemaVersion}`);
				this.#bpData = bp as BlueprintData;
				break;
			case -1:
				this.updateRaw();
				break;
			default:
				this.updateSchema();
		}
	}

	// ------------------------------------------
	// ----------- Getters / Setters ------------
	// ------------------------------------------
	get bpData (): BlueprintData { return this.#bpData;	}

	// ----------------------------------------
	// ----------- Private Methods ------------
	// ----------------------------------------
	private updateRaw (): void {
		const bp = this.#bpUnknown as RawBlueprint;
		try {
			console.log(`schema-update:process-update:raw->${this.currentSchemaVersion}`);
			this.#bpData = (new ProcessRawBlueprint(bp)).blueprintData;
		} catch (err) {
			console.warn(`schema-update:process-update:raw->${this.currentSchemaVersion}:failed`, err);
			this.#bpData = null;
		}
	}

	private updateSchema (): void {
		let updatedBlueprint = deepCopy(this.#bpUnknown) as UnknownBlueprint;

		if (typeof (updatedBlueprint as any).state === 'string') {
			(updatedBlueprint as any).state = JSON.parse(((updatedBlueprint as any).state) as unknown as string);
		}

		try {
			console.log(`schema-update:process-update:${this.#bpSchemaVersion}->${this.currentSchemaVersion}`);
			if (this.currentSchemaVersion > updatedBlueprint.schemaVersion) {
				for (let version = updatedBlueprint.schemaVersion + 1; this.currentSchemaVersion > updatedBlueprint.schemaVersion; version++) {
					if (updatedBlueprint !== null) updatedBlueprint = (updates[version] as (br: unknown) => UnknownBlueprint)(updatedBlueprint);
				}
				this.#bpData = updatedBlueprint as BlueprintData;
			}
		} catch (err) {
			console.log(`schema-update:process-update:${this.#bpSchemaVersion}->${this.currentSchemaVersion}:failed`, err);
			this.#bpData = null;
		}
	}
}

// export const processSchema = (blueprint: Blueprint | BlueprintRaw): Blueprint => {
// 	let schemaVersion = (blueprint as Blueprint).schemaVersion || -1;
// 	const isRaw = schemaVersion === -1 && (blueprint.state || '[]') === '[]';

// 	let isNew = false;
// 	let updatedBlueprint: Blueprint = null;

// 	try {
// 		console.log('current schema:', { ...blueprint });
// 		if (isRaw) {
// 			[updatedBlueprint, isNew] = (updates[0] as (bpr:BlueprintRaw) => [Blueprint, boolean])(blueprint as BlueprintRaw);
// 		} else {
// 			updatedBlueprint = blueprint as Blueprint;
// 		}

// 		if (isRaw) {
// 			console.log(`processSchema: schema update required (${schemaVersion} -> ${currentSchemaVersion})`);
// 		} else {
// 			updatedBlueprint.islands = JSON.parse((updatedBlueprint.islands) as unknown as string);
// 			updatedBlueprint.state = JSON.parse((updatedBlueprint.state) as unknown as string);

// 			// update saved BP that are missing schemaVersion to 5
// 			if ((updatedBlueprint.schemaVersion || null) === null) {
// 				schemaVersion = 5;
// 				updatedBlueprint.schemaVersion = 5;
// 			}
// 		}

// 		if (currentSchemaVersion > updatedBlueprint.schemaVersion) {
// 			for (let version = updatedBlueprint.schemaVersion + 1; currentSchemaVersion > updatedBlueprint.schemaVersion; version++) {
// 				updatedBlueprint = (updates[version] as (br: Blueprint) => Blueprint)(updatedBlueprint);
// 			}
// 		}

// 		// when isNew => align appliances
// 		if (isNew) {
// 			const map = buildReferenceMap(updatedBlueprint.state[0]);
// 			updatedBlueprint.state[0].islands.forEach((island) => {
// 				island.panels.forEach((panel) => {
// 					distributeApplianceGroupsHorizontally({ map, refKey: panel.key });
// 				});
// 			});
// 		}

// 		if (blueprint.image) updatedBlueprint.image = blueprint.image;
// 	} catch (err) {
// 		console.warn(err);
// 	}

// 	console.log(`processSchema: process complete (${schemaVersion} -> ${updatedBlueprint.schemaVersion})`, updatedBlueprint);

// 	return updatedBlueprint;
// };
